import BaseStore from './base'

const schema = {
  recorded_datetime: Number,
  position_timestamp: Number,
  position_longitude: Number,
  position_latitude: Number,
  position_accuracy: Number,
  'position_heading?': Number,
  'position_speed?': Number,
  'field?': String,
  'network?': Number,
  'battery_percentage?': Number,
  'battery_charging?': Boolean,
  campaign_id: String,
  emitter_id: String
}

export default class TraceStore extends BaseStore {
  #lastTrace
  #lastSync

  static get storageKey () { return 'tracker-traces' }
  static get apiFunction () { return 'postTraces' }
  static get rawSchema () { return schema }

  get lastSync () { return this.#lastSync }

  activateAutosync () {}

  isAwaitingTrace (trace, traceRate) {
    // console.log('TraceStore.isAwaitingTrace')
    if (!trace.position_timestamp) return false
    if (!this.#lastTrace) return true
    return (trace.recorded_datetime - this.#lastTrace) > traceRate
  }

  isAwaitingSync () {
    // console.log('TraceStore.isAwaitingSync')
    if (this.isSyncing) return false
    if (!this.#lastSync) return true
    return (Date.now() - this.#lastSync) > this.options.syncRate
  }

  async push (entry) {
    if (!entry) return
    this.#lastTrace = entry.recorded_datetime
    // console.log('TraceStore.push')
    return super.push(entry)
  }

  async sync () {
    // console.log('TraceStore.sync')
    this.#lastSync = Date.now()
    return super.sync()
  }

  static deflate (d) {
    return {
      recorded_datetime: d.recorded_datetime,
      position_timestamp: d.recorded_datetime - d.position_timestamp,
      position_longitude: Math.floor((d.position_longitude - 7) * 100000),
      position_latitude: Math.floor((d.position_latitude - 49) * 100000),
      position_accuracy: d.position_accuracy,
      position_heading: d.position_heading ? Math.floor(d.position_heading) : undefined,
      position_speed: d.position_speed ? Math.round(d.position_speed * 3.6) : undefined,
      field: d.field ? d.field.replace('-0', '') : undefined,
      network: d.network ? ['none', '2g', '3g', '4g', 'wifi'].indexOf(d.network) : undefined,
      battery_percentage: d.battery_percentage ? Math.floor(d.battery_percentage) : undefined,
      battery_charging: d.battery_charging,
      campaign_id: d.campaign_id,
      emitter_id: d.emitter_id
    }
  }
}
